import React from "react";
import { Link } from "react-router-dom"

const Breadcrumbs = ({nombreDestino, destino, isCdr = false}) => {
    return (
        <ul className="breadcrumbs">
        <li>
          <Link to="/">Home </Link>
        </li>
        <li>
          {!isCdr && " Paquetes " }
          {isCdr && <Link to="/hoteles"> Hoteles </Link>}
        </li>
        <li>
          {" "}
          {nombreDestino} ({destino})
        </li>
      </ul>
    )
}

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/Resultados/breadcrumbs.js